import { useTrackingLiveGuardCta } from '@ecomm/tracking/useTrackingLiveGuardCta'
import { useCallback } from 'react'

export function useOnLiveGuardCtaClick() {
  const trackLiveGuardCtaClick = useTrackingLiveGuardCta()

  return useCallback(() => {
    trackLiveGuardCtaClick()
  }, [trackLiveGuardCtaClick])
}
